import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Building } from '@app/shared/models/building.interface';

@Injectable({
    providedIn: 'root'
})
export class BuildingService {
    private readonly currentBuildingSource = new BehaviorSubject<Building>(null);

    constructor() {}

    get currentBuilding$() {
        return this.currentBuildingSource.asObservable();
    }

    setCurrentBuilding(building: Building): void {
        this.currentBuildingSource.next(building);
    }
}
